import type { RootState } from '../configureStore'

export const selectAddress = (state: RootState) => state.user.wallet?.address
export const selectWallet = (state: RootState) => state.user.wallet
export const selectAuthData = (state: RootState) => state.user.auth.data
export const selectAuthRequested = (state: RootState) => state.user.auth.requested
export const selectAuthRejected = (state: RootState) => state.user.auth.rejected
export const selectIsAuthenticated = (state: RootState) =>
  state.user.auth.data?.ethAddress !== null && state.user.auth.data?.ethAddress !== undefined
export const selectContractWallet = (state: RootState) => state.user.contractWallet
export const selectConnectedNetwork = (state: RootState) => state.user.network
